//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { Enums } from '../common/enums'

import { DataProvider } from '../../helpers/data-provider'
import { TypeHelper } from '../../helpers/type-helper'

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'

import { OpDescr } from './op-descr'

export class OpIssueStatus implements IReferenceType, IOpChangeState, IJsonSerializable {

    // Members

    public idIssueStatus: number
    public idDescr: number

    public description: string
    
    public descr: OpDescr

    // Members End


    // Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // Ctor End


    // IOpChangeState Implementation

    public opState: Enums.OpChangeState

    // IOpChangeState Implementation End


    // IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdIssueStatus
    }

    public getReferenceKey(): number {
        return this.idIssueStatus
    }

    public getReferenceValue(): any {
        return this
    }

    public toString(): string {
        if (this.descr != null) {
            return this.descr.description
        }

        return this.description
    }

    // IReferenceType Implementation End


    // IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || TypeHelper.isJSONCompressed(opObj)) {
                this.idIssueStatus = opObj.I
                this.idDescr = opObj.ID

                this.description = opObj.D

                this.descr = opObj.DE != null ? new OpDescr(opObj.DE) : null
                this.opState = opObj.O
            }
            else {
                this.idIssueStatus = opObj.ID_ISSUE_STATUS
                this.idDescr = opObj.ID_DESCR


                this.description = opObj.DESCRIPTION

                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
            }
        }

    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            const result: any = {
                I: this.idIssueStatus,
                ID: this.idDescr,

                D: this.description,
                DE: this.descr != null ? this.descr.toJSON(compressed) : null,

                O: this.opState
            }

            TypeHelper.setJSONCompressedFlag(result)
            TypeHelper.deleteNulls(result)

            return result
        }

        return {
            ID_ISSUE_STATUS: this.idIssueStatus,
            ID_DESCR: this.idDescr,

            DESCRIPTION: this.description,

            _Descr: this.descr != null ? this.descr.toJSON(compressed) : null,
            OpState: this.opState
        }
    }

    // IJsonSerializable Implementation End


    public static loadNavigationProperties(dataProvider: DataProvider, list: OpIssueStatus[]): JQueryPromise<OpIssueStatus[]> {
        const deferred: JQueryDeferred<OpIssueStatus[]> = $.Deferred<OpIssueStatus[]>()

        deferred.resolve(list)

        return deferred.promise()
    }
}